export default (function () {
  
  /*let TIMEOUT = null;
    window.onresize = () => {
      if(TIMEOUT === null) {
        TIMEOUT = window.setTimeout(() => {
          TIMEOUT = null;
          //fb_iframe_widget class is added after first FB.FXBML.parse()
          //fb_iframe_widget_fluid is added in same situation, but only for mobile devices (tablets, phones)
          //By removing those classes FB.XFBML.parse() will reset the plugin widths.

          document.querySelector('.fb-page').classList.remove('fb_iframe_widget');
          document.querySelector('.fb-page').classList.remove('fb_iframe_widget_fluid')
          FB.XFBML.parse();
        }, 90);
      }
    }*/
    
})();